// extracted by mini-css-extract-plugin
export default {"firstP":"PaymentMethodInfo_firstP","iconAndText":"PaymentMethodInfo_iconAndText","header":"PaymentMethodInfo_header"};